// export const formulario = (state) => state.formulario;

// export const vehiculo = (state) => state.formulario.vehiculo;

export const acreedorPrendario = (state) => state.formulario.acreedorPrendario;
export const pago = (state) => state.formulario.pago;

export const cotizaciones = (state) => state.cotizaciones;

export const cotizacionesSeleccionadas = (state) => {
   return state.cotizaciones?.filter((cot) => cot.seleccionada);
};

export const cantidadSeleccionadas = (state) => {
   return state.cotizaciones?.filter((cot) => cot.seleccionada).length;
};

export const mostrarComparacion = (state) => state.mostrarComparacion;

export const opcionesOrden = (state) => state.opcionesOrden;
export const filtrosCotizacion = (state) => state.filtrosCotizacion;

// export const marcaOptions = (state) => state.marcaOptions;

// export const modeloOptions = (state) => state.modeloOptions;

export const versionOptions = (state) => state.versionOptions;
export const rastreadorOptions = (state) => state.rastreadorOptions;
export const actividadOptions = (state) => state.actividadOptions;
export const ingresosBrutosOptions = (state) => state.ingresosBrutosOptions;
export const canalPagoOptions = (state) => state.canalPagoOptions;
export const accesoriosOptions = (state) => state.accesoriosOptions;
// export const tipoPersonaOptions = (state) => state.tipoPersonaOptions;

export const tabsCotizaciones = (state) => state.tabsCotizaciones;

export const datosCotizacion = (state, getters, rootState) => {
   //en módulos namespaced de Vuex, los parámetros son (state, getters, rootState, rootGetters).
   const { vehiculo } = state.formulario;
   const cliente = rootState.cliente?.cliente || {};
   const poliza = rootState.poliza?.poliza || {};
   const anio = vehiculo.anio ? vehiculo.anio.getFullYear() : null;

   let datosCotizacion = {
      infoAuto: vehiculo.modelo, //120574, //120574 460913
      codigoPostal: cliente.codigo_postal, //2300,
      anio: anio, //2020,
      tipoUso: vehiculo.tipoUso, //1,
      tieneGNC: vehiculo.tieneGnc, //false,
      tieneTracking: vehiculo.tieneRastreo, //false,
      tipoRastreador: vehiculo.rastreo?.tipoRastreador || 0,
      esCeroKm: vehiculo.ceroKm, //false,
      tipoIva: cliente.id_condicion_fiscal || 3, //3,
      tipoPersona: cliente.tipo_persona, //"FISICA",
      cuit: cliente.cuit, //20409682635,
      localidad: cliente.id_localidad || poliza.id_localidad,
      accesorios: vehiculo.accesorios,
      valorAccesorioGnc: vehiculo.gnc?.sumaAseguradaAccesorio,
      tieneGarage: vehiculo.tieneGarage,
      esCamion: !!vehiculo.esCamion,
   };

   return datosCotizacion;
};

export const datosVehiculoProspect = (state) => {
   const { vehiculo } = state.formulario;
   const anio = vehiculo.anio ? vehiculo.anio.getFullYear() : null;

   return {
      infoauto: vehiculo.modelo ? vehiculo.modelo : null,
      cero_km: vehiculo.ceroKm,
      traqueo: vehiculo.tieneRastreo,
      gnc: vehiculo.tieneGnc,
      tipo_uso: vehiculo.tipoUso,
      anio: anio,
      marca: vehiculo.marcaDescripcion,
      modelo: vehiculo.modeloDescripcion,
      garaje: vehiculo.tieneGarage,
      dominio: vehiculo.patente,
      tipoRastreador: vehiculo.rastreo?.tipoRastreador || null,
      accesorios: Array.isArray(vehiculo.accesorios) && vehiculo.accesorios.length > 0 ? vehiculo.accesorios : null,
      gncData: vehiculo.tieneGnc && vehiculo.gnc && Object.keys(vehiculo.gnc).length > 0 ? vehiculo.gnc : null,
   };
};
